/*
  Desktop navigation guard (self-healing).

  Tinker's header menu is an <overflow-list>. It measures how many items fit and
  parks the rest in its own hidden `slot="overflow"`, and `header.js` reacts to
  the "minimum reached" event by hiding the ENTIRE desktop menu and swapping in
  the mobile drawer. With a menu column sized `auto` that first measurement can
  run before the grid track resolves, decide nothing fits, and leave the nav
  collapsed for good — the items are out of flow, so the column stays narrow and
  nothing re-measures.

  A one-off pass on load is not enough: the theme re-measures whenever fonts and
  images settle, and the theme editor re-renders the header section outright.
  This file therefore watches the header group and undoes the collapse whenever
  it happens, on screens wide enough to be a real navigation bar.

  Phones are untouched — the drawer is the correct pattern there — and no Liquid
  business logic is involved.
*/
(function () {
  var MIN_WIDTH = 990;

  function restore() {
    if (window.innerWidth < MIN_WIDTH) return;
    var group = document.getElementById('header-group');
    if (!group) return;

    var menu = group.querySelector('header-menu');
    if (menu) menu.classList.remove('hidden');

    // the theme shows the hamburger at the same time it hides the bar
    group.querySelectorAll('.header__drawer').forEach(function (drawer) {
      drawer.classList.add('desktop:hidden');
    });

    group.querySelectorAll('overflow-list > li[slot="overflow"]').forEach(function (item) {
      item.removeAttribute('slot');
    });

    group.querySelectorAll('overflow-list').forEach(function (list) {
      if (list.hasAttribute('minimum-reached')) list.removeAttribute('minimum-reached');
      if (typeof list.showAll === 'function') {
        try { list.showAll(); } catch (error) { /* older build */ }
      }
    });
  }

  // Coalesce bursts of mutations into one pass, and let restore() run to
  // completion before deciding whether anything else changed.
  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      restore();
    });
  }

  function boot() {
    var group = document.getElementById('header-group');
    if (!group) return;

    restore();

    if (window.MutationObserver) {
      new MutationObserver(queue).observe(group, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'minimum-reached', 'slot'],
      });
    }

    window.addEventListener('resize', queue);
    // the theme editor swaps sections in and out
    document.addEventListener('shopify:section:load', queue);
    document.addEventListener('shopify:block:select', queue);
    // and the first seconds are when fonts and lazy images land
    [100, 400, 900, 1600, 2600, 4000, 6000].forEach(function (delay) {
      setTimeout(queue, delay);
    });
  }

  if (document.readyState === 'complete') boot();
  else window.addEventListener('load', boot);
})();
